import { Injector } from 'injection-js';
import { NodeTypeConfigHelper, NodeTypeConfigHelperConstructor } from '../../../connector/connector-form/helpers/node-config-helper';
import { NodeConfigHelperService } from '../../../connector/connector-form/helpers/node-config-helper.service';
import { TARGET_TYPES, TargetTypesEnum } from '../models/target-type';


export class TargetConfigHelperService extends NodeConfigHelperService {
  static deps = [
    Injector
  ];

  constructor(
    protected _injector: Injector
  ) {
    super(_injector);
  }

  getConfigHelperClass(nodeTypeIdentifier: string): NodeTypeConfigHelperConstructor {
    return TARGET_TYPES[nodeTypeIdentifier].configHelper;
  }

  getConfigHelperClassInstance(nodeTypeIdentifier: string): NodeTypeConfigHelper {
    const configHelperClass = this.getConfigHelperClass(nodeTypeIdentifier);

    if (nodeTypeIdentifier === TargetTypesEnum.GOOGLE_SHEETS) {
      return new configHelperClass();
    }

    return new configHelperClass();
  }
}
